var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.loadingState)?_c('loader'):_c('div',[(_vm.data.length < 1)?_c('v-row',[_c('no-data',{staticClass:"mx-auto"})],1):_vm._e(),_c('videos',{attrs:{"videos":_vm.data}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }